import Vue from 'vue'
import Router from 'vue-router'
import VueHead from 'vue-head'
import store from '@/store/index'

import MypageTemplate from '@/components/_base/MypageTemplate'
import TopTemplate from '@/components/_base/TopTemplate'
import InformationTemplate from '@/components/_base/InformationTemplate'
import AuthTemplate from "@/components/_base/AuthTemplate";

import Top from '@/components/pages/Top'
import Terms from '@/components/pages/information/Terms'
import Usages from '@/components/pages/information/Usages'
import PrivacyPolicy from '@/components/pages/information/PrivacyPolicy'
import About from '@/components/pages/information/About'
import AboutSkills from '@/components/pages/information/AboutSkills'
import Contact from '@/components/pages/information/Contact'

import RegistrationUser from '@/components/pages/auth/RegistrationUser'
import RegistrationStaff from '@/components/pages/auth/staff/RegistrationStaff'
import ConfirmStaff from '@/components/pages/auth/staff/ConfirmStaff'
import RegistrationUserDetail from '@/components/pages/auth/RegistrationUserDetail'
import Login from '@/components/pages/auth/Login'
import ResetPassword from '@/components/pages/auth/ResetPassword'

import MypageTop from '@/components/pages/mypage/MypageTop'
import ClientTop from '@/components/pages/mypage/client/ClientTop'
import OperatorTop from '@/components/pages/mypage/operator/OperatorTop'
import UpdatingOperator from '@/components/pages/mypage/operator/UpdatingOperator'
import RetrievingMatchings from '@/components/pages/mypage/operator/RetrievingMatchings'

import PaymentTop from '@/components/pages/mypage/operator/payment/PaymentTop'
import VerifyingCustomAccount from '@/components/pages/mypage/operator/payment/VerifyingCustomAccount'
import RegistrationBank from '@/components/pages/mypage/operator/payment/RegistrationBank'
import PayoutBalances from '@/components/pages/mypage/operator/payment/PayoutBalances'
import PayoutLogs from '@/components/pages/mypage/operator/payment/PayoutLogs'

import RegisterUserSkill from '@/components/pages/mypage/user/RegisterUserSkill'
import UserDetail from '@/components/pages/mypage/user/UserDetail'
import UpdatingUserDetail from '@/components/pages/mypage/user/UpdatingUserDetail'
import UpdatingOffice from '@/components/pages/mypage/user/UpdatingOffice'

import CreatingWork from '@/components/pages/mypage/client/work/CreatingWork'
import UpdatingWork from '@/components/pages/mypage/client/work/UpdatingWork'
import RetrievingWorks from '@/components/pages/mypage/client/work/RetrievingWorks'
import WorkDetail from '@/components/pages/mypage/client/work/WorkDetail'

import MatchingDetail from '@/components/pages/matching/pre/MatchingDetail'
import OperatorDetail from '@/components/pages/matching/pre/OperatorDetail'
import ClientDetail from '@/components/pages/matching/pre/ClientDetail'
import Meeting from '@/components/pages/matching/meeting/Meeting'
import TempWorkDetail from '@/components/pages/matching/meeting/TempWorkDetail'
import Payment from '@/components/pages/matching/meeting/Payment'
import CreatingBill from '@/components/pages/matching/meeting/CreatingBill'
import CreatingClientScore from '@/components/pages/matching/suf/CreatingClientScore'
import CreatingOperatorScore from '@/components/pages/matching/suf/CreatingOperatorScore'

Vue.use(VueHead);
Vue.use(Router);

export default new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  },
  routes: [
    {
      path: '/',
      component: TopTemplate,
      children: [
        {
          path: '',
          name: 'Top',
          component: Top,
        },
      ]
    },

    {
      path: '/information',
      component: InformationTemplate,
      children: [
        {
          path: 'terms',
          name: 'Terms',
          component: Terms,
        },
        {
          path: 'privacy_policy',
          name: 'PrivacyPolicy',
          component: PrivacyPolicy,
        },
        {
          path: 'about',
          name: 'About',
          component: About,
        },
        {
          path: 'about_skills',
          name: 'AboutSkills',
          component: AboutSkills,
        },
        {
          path: 'usages',
          name: 'Usages',
          component: Usages,
        },
        {
          path: 'contact',
          name: 'Contact',
          component: Contact,
        },
      ]
    },

    /** 認証系 */
    {
      path: '/auth',
      component: AuthTemplate,
      children: [
        {
          path: 'registration_user',
          name: 'RegistrationUser',
          component: RegistrationUser,
          beforeEnter: ((to, from, next) => {
            if (store.getters['auth/isLogin']) next({name: 'MypageTop'});
            else next();
          })
        },
        {
          path: 'registration_user_detail',
          name: 'RegistrationUserDetail',
          component: RegistrationUserDetail,
          beforeEnter: ((to, from, next) => {
            if (store.getters['auth/customClaim/hasUserDetail']) next({name: 'MypageTop'});
            else next();
          })
        },
        {
          path: 'login',
          name: 'Login',
          component: Login,
          beforeEnter: ((to, from, next) => {
            if (store.getters['auth/isLogin']) next({name: 'MypageTop'});
            else next();
          })
        },
        {
          path: 'staff/registration_staff/:officeId',
          name: 'RegistrationStaff',
          component: RegistrationStaff,
          beforeEnter: ((to, from, next) => {
            if (store.getters['auth/isLogin']) next({name: 'MypageTop'});
            else next();
          })
        },
        {
          path: 'staff/confirm_staff/:staffId',
          name: 'ConfirmStaff',
          component: ConfirmStaff,
          beforeEnter: ((to, from, next) => {
            if (!store.getters['auth/isLogin']) next({name: 'Login'});
            else next();
          }),
        },
        {
          path: 'reset_password',
          name: 'ResetPassword',
          component: ResetPassword
        },
      ]
    },

    /** マイページ */
    {
      path: '/mypage',
      component: MypageTemplate,
      beforeEnter: ((to, from, next) => {
        if (!store.getters['auth/isLogin']) next({name: 'Login'});
        else next();
      }),
      children: [
        {
          path: '',
          name: 'MypageTop',
          component: MypageTop
        },
        {
          path: 'register_user_skill',
          name: 'RegisterUserSkill',
          component: RegisterUserSkill
        },
        {
          path: 'user/detail',
          name: 'UserDetail',
          component: UserDetail
        },
        {
          path: 'user/updating_user_detail',
          name: 'UpdatingUserDetail',
          component: UpdatingUserDetail
        },
        {
          path: 'user/updating_office',
          name: 'UpdatingOffice',
          component: UpdatingOffice
        },
      ]
    },

    /** クライアント */
    {
      path: '/mypage/client',
      component: MypageTemplate,
      beforeEnter: ((to, from, next) => {
        if (!store.getters['auth/isLogin']) next({name: 'Login'});
        else next();
      }),
      children: [
        {
          path: '',
          name: 'ClientTop',
          component: ClientTop
        },
        {
          path: 'work/create',
          name: 'CreatingWork',
          component: CreatingWork
        },
        {
          path: 'work/update/:workId',
          name: 'UpdatingWork',
          component: UpdatingWork
        },
        {
          path: 'work/list',
          name: 'RetrievingWorks',
          component: RetrievingWorks
        },
        {
          path: 'work/detail/:workId',
          name: 'WorkDetail',
          component: WorkDetail
        },
      ]
    },

    /** オペレーター */
    {
      path: '/mypage/operator',
      component: MypageTemplate,
      beforeEnter: ((to, from, next) => {
        if (!store.getters['auth/isLogin']) next({name: 'Login'});
        else next();
      }),
      children: [
        {
          path: '',
          name: 'OperatorTop',
          component: OperatorTop
        },
        {
          path: 'update',
          name: 'UpdatingOperator',
          component: UpdatingOperator
        },
        {
          path: 'matching/list',
          name: 'RetrievingMatchings',
          component: RetrievingMatchings
        },
        {
          path: 'payment',
          name: 'PaymentTop',
          component: PaymentTop
        },
        {
          path: 'payment/verifying_custom_account',
          name: 'VerifyingCustomAccount',
          component: VerifyingCustomAccount
        },
        {
          path: 'payment/registration_bank',
          name: 'RegistrationBank',
          component: RegistrationBank
        },
        {
          path: 'payment/payout_balances',
          name: 'PayoutBalances',
          component: PayoutBalances
        },
        {
          path: 'payment/payout_logs',
          name: 'PayoutLogs',
          component: PayoutLogs
        },
      ]
    },

    /** マッチング */
    {
      path: '/matching',
      component: MypageTemplate,
      children: [
        {
          path: 'pre/detail/:matchingId',
          name: 'MatchingDetail',
          component: MatchingDetail
        },
        {
          path: 'pre/client/:clientId',
          name: 'ClientDetail',
          component: ClientDetail
        },
        {
          path: 'pre/operator/:operatorId',
          name: 'OperatorDetail',
          component: OperatorDetail
        },
        {
          path: 'meeting/:matchingId/message/list',
          name: 'Meeting',
          component: Meeting
        },
        {
          path: 'meeting/payment/:matchingId',
          name: 'Payment',
          component: Payment
        },
        {
          path: 'meeting/temp_work/:matchingId',
          name: 'TempWorkDetail',
          component: TempWorkDetail
        },
        {
          path: 'meeting/:matchingId/bill/create',
          name: 'CreatingBill',
          component: CreatingBill
        },
        {
          path: 'suf/:matchingId/score/create/operator',
          name: 'CreatingOperatorScore',
          component: CreatingOperatorScore
        },
        {
          path: 'suf/:matchingId/score/create/client',
          name: 'CreatingClientScore',
          component: CreatingClientScore
        },
      ]
    },
  ]
})
